import { _initialState } from './_initialState';
import { updateMediaAssets } from './actions';

export const mediaStore = (set) => ({
  ..._initialState,
  updateMediaAssets: (media) => updateMediaAssets(set, media)
});
